import { useQuery, useQueryClient } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { PageContent } from '@/components/page-content';
import {
  ConsentForm,
  ConsentLoadingCard,
  QUERY_KEY,
} from '@/components/settings/consent-settings';
import { ConsentSettingsService } from '@/api/consent-settings-service';

export const Route = createFileRoute(
  '/_auth/_side-layout/settings_/privacy/user-consent',
)({
  component: () => (
    <PageContent>
      <UserConsentContent />
    </PageContent>
  ),
});

// Privacy → User Consent: consent behavior + analytics-denied handling. The
// form always seeds + submits the full settings bundle; `sections` scopes only
// what's rendered, so splitting across tabs never clobbers hidden fields.
function UserConsentContent() {
  const queryClient = useQueryClient();
  const { data, isLoading, error } = useQuery({
    queryKey: QUERY_KEY,
    queryFn: () => ConsentSettingsService.getConsentSettings(),
    retry: false,
  });

  if (isLoading || error || !data) {
    return <ConsentLoadingCard isLoading={isLoading} />;
  }

  return (
    <ConsentForm
      settings={data}
      sections={['behavior', 'denied']}
      onSave={(input) => ConsentSettingsService.updateConsentSettings(input)}
      onSaved={(next) => queryClient.setQueryData(QUERY_KEY, next)}
    />
  );
}
